import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';  
import Checkbox from '@mui/material/Checkbox';
import { Button } from '@mui/material'; // Importing Button from Material-UI
import EditModal from './editModal';
import DeleteModal from './deleteModal';

const NextCase = () => {
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [rows, setRows] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [descriptionColumns, setDescriptionColumns] = useState([]);
  const [, setMaxDescriptions] = useState(0);

  const fetchEntries = async () => {
    const response = await fetch('https://hms.backend.hiragroupcloud.com/api/all-next-types');
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.json();

    
    const maxDescs = Math.max(...data.data.map(item => item?.descriptions?.length));
    setMaxDescriptions(maxDescs);
    
    const columns = [];
    for (let i = 0; i < maxDescs; i++) {
      columns.push({ field: `description_${i + 1}`, headerName: `Description ${i + 1}`, width: 150, align: 'center', headerAlign: 'center' });
    }
    setDescriptionColumns(columns);

    const transformedRows = data.data.map(item => {
      const descriptionFields = {};
      item?.descriptions.forEach((desc, index) => {
        descriptionFields[`description_${index + 1}`] = desc?.description;
      });

      return {
        _id: item._id,
        name: item.name,
        procedure: item.procedure,
        Note: item.checkboxes.copyPracticeNote ? true : false,
        ...descriptionFields,
        description: item?.descriptions,
        CaseTypeId: item.caseTypeId,
        copyPracticeNote: item.checkboxes.copyPracticeNote,
        copyPracticeFiles: item.checkboxes.copyPracticeFiles,
        requireNote: item.checkboxes.requireNote ? true : false,
        requireDescription: item.checkboxes.requireDescription,
      };
    });
    setRows(transformedRows);
  };

  useEffect(() => {
    fetchEntries();
  }, []);

  const handleEdit = async (id) => {

    setShowModal(true);
    const selectedRow = rows.filter((row) => row._id === id);
    setSelectedData(selectedRow);
  };

  const handleDelete = (id) => {

    setShowDeleteModal(true);
    setRows(rows.filter(row => row._id !== id)); 
  };

  const handleRowClick = (row) => { 
    const { _id } = row;
    setSelectedRowId(_id === selectedRowId ? null : _id);
  };

  const renderNoteCell = (params) => {
    return (
      <Checkbox
        checked={params.value === true}
        readOnly
      />
    );
  };

  const baseColumns = [
    { field: 'name', headerName: 'Name', width: 150 },
    { field: 'procedure', headerName: 'Procedure', width: 200, align: 'center', headerAlign: 'center' },
    { field: 'requireNote', headerName: 'Note', width: 150, align: 'center', headerAlign: 'center', renderCell: renderNoteCell },
  ];

  const allColumns = [
    ...baseColumns,
    ...descriptionColumns,
  ];

  const [searchTerm, setSearchTerm] = useState('');
  const filteredRows = rows.filter(row =>
    Object.values(row).some(value =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  return (
    <>
      <h2 className="title"style={{ border: 'white', borderBottom: '3px solid #004aad', padding: '10px' }}>Next-case Types</h2> 
      <div className="search">
        <div className="row align-items-center">
          <div className="col-md-9 d-flex justify-content-between">
            <div className="col-md-3 d-flex justify-content-start">
              <input
                type="text"
                id="searchInput"
                className="form-control"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
          <div className="col-md-3 d-flex justify-content-end">
            <Link to="/AddNextcaseType" className="btn btn-primary" style={{backgroundColor:"#004aad",borderColor:"#004aad"}}>Add</Link>
          </div>
        </div>
      </div>

      <div style={{ height: 400, width: '100%', position: 'relative', marginTop: '2%', background: '#f0f0f5' }}>
        <DataGrid
          rows={filteredRows}
          columns={allColumns}
          pageSize={5}
          rowSelected={selectedRowId !== null}
          onRowClick={(params) => handleRowClick(params.row)}
          getRowId={(row) => row._id}
          components={{
            Toolbar: () => null,
          }}
          sx={{
            '& .MuiDataGrid-columnHeaderTitle': {
              fontWeight: 'bold',
            }, 
            '& .MuiDataGrid-cell:focus': {
              outline: 'none',  
            },
            '& .MuiDataGrid-cell:focus-within': {
              outline: 'none',  
            },
          }}
        />
        {selectedRowId !== null && (
          <div
            style={{
              position: 'absolute',
              top: rows.findIndex(row => row._id === selectedRowId) * 52 + 48,
              right: '10px',
              display: 'flex',
              marginTop: '15px'
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleEdit(selectedRowId)}
              sx={{ marginRight: 1 }}
            >
              Edit
            </Button>
            <Button
              variant="contained"
              sx={{ backgroundColor: 'red', '&:hover': { backgroundColor: '#c62828' } }}
              onClick={() => handleDelete(selectedRowId)}
            >
              Delete
            </Button>
          </div>
        )}
      </div>
      <EditModal 
        showModal={showModal} 
        handleClose={() => setShowModal(false)} 
        selectedRowData={selectedData}
      />

      <DeleteModal 
        showDeleteModal={showDeleteModal} 
        handleClose={() => setShowDeleteModal(false)} 
        selectedRowId={selectedRowId}
      />
    </>
  );
};

export default NextCase;
